<template>
    <header class="header header--admin">
        <div class="header__image">
            <router-link :to="{name: 'admin.homepage'}">
                <img src="@/assets/images/logo.svg" alt="" />
            </router-link>
        </div>
        <div class="header__right">
            <div class="header__icon">
                <img src="@/assets/icons/admin/notifications.svg" alt="" />
            </div>
            <div class="header__icon">
                <img src="@/assets/icons/admin/message.svg" alt="" />
            </div>
            <div class="header__name" @click="openMenu">
                {{userInitial}}
                <div class="header__name-list">
                    <ul>
                        <li>
                            <router-link :to="{name: 'admin.profile'}" class=""
                            ><img src="@/assets/icons/admin/profile.svg" width="17.484" height="17.975" alt="Twój profil" />{{$t('admin.general.your_profile')}}</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'admin.settings'}" class=""
                            ><img src="@/assets/icons/admin/settings-black.svg" width="17.484" height="17.975" alt="Ustawienia" />{{$t('admin.general.settings')}}</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'logout'}">
                                <img src="@/assets/icons/admin/logout.svg" width="17.484" height="17.975" :alt="$t('admin.general.logout')" />
                                {{$t('admin.general.logout')}}
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
    <div class="header-overlay"></div>

    <div class="wrapper">
        <Menu :is-admin="true"></Menu>
        <vue-basic-alert ref="alert" />
        <router-view />
    </div>

</template>

<script>
import Menu from "@/components/Menu";
import {inject, provide, ref, watch} from "vue";
import VueBasicAlert from "vue-basic-alert";
import UserService from "@/services/user.service";
import {useAuthStore} from "@/stores/auth.store";
import breakpointsHelper from "@/helpsers/breakpoints.helper";
import { useMenuStore } from "@/stores/menu.store";

export default {
    name: "AdminLayout",
    components: {Menu,VueBasicAlert},
    setup() {
        const authStore = useAuthStore(),
            allLoaded = ref(false),
            alert = ref(),
            userInitial = UserService.getUserInitials(authStore.user),
            {width, type} = breakpointsHelper();
        const menuStore = useMenuStore()
        provide('alert', alert);

        const openMenu = () => {
            menuStore.isOpen = !menuStore.isOpen;
        }

        return {
            openMenu,
            alert,
            allLoaded,
            userInitial
        }
    }
}
</script>

<style scoped lang="scss">
.header {
    &__name {
        &-list {
            a {
                img {
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>
